import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api/api.service';

import { ProfileCustomField } from './model/profile-custom-field.model';
import { ApiCacheOptions } from 'src/app/shared';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileCustomFieldService {
  private _apiService: ApiService;
  private _noCacheOption: ApiCacheOptions;

  public constructor(apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {
    this._apiService = apiService;

    this._noCacheOption = new ApiCacheOptions();
    this._noCacheOption.CacheSeconds = 0;
    this._noCacheOption.DeleteCache = true;
    this._noCacheOption.DisableCaching = true;
    this._noCacheOption.DisableSlidingCache = true;
  }

  public getProfileCustomFieldsForProfileId(profileId: number, forceRefresh?: boolean): Promise<Array<ProfileCustomField>> {
    return this._profileServiceApiService.get(`profile/v2/${profileId}/CustomFields`);
  }

  public createProfileCustomField(profileId: number, dto: ProfileCustomField): Promise<number> {
    return this._apiService.post(`Profile/${profileId}/CustomFields`, dto);
  }

  public updateProfileCustomField(profileId: number, dto: ProfileCustomField): Promise<void> {
    return this._apiService.put(`Profile/${profileId}/CustomFields/${dto.CustomFieldId}`, dto);
  }

  public deleteProfileCustomField(profileId: number, profileCustomFieldId: number): Promise<void> {
    return this._apiService.delete(`Profile/${profileId}/CustomFields/${profileCustomFieldId}`);
  }
}
